export const errorMessage = {
    "USER_NOT_AUTHENTICATED": "ບໍ່ຮອງຮັບ.",
    "USER_NOT_FOUND": "ບໍ່ພົບຜູ້ໃຊ້.",
    "NOT_EXITS_PHONE_NUMBER": "ຂໍອະໄພ, ບໍ່ມີເບີໂທລະສັບ.",
    "USER_CANT_ACCESS_AN_EXAM": "ຂໍອະໄພ, ເບີໂທລະສັບຂອງທ່ານບໍ່ມີຢູ່ໃນລາຍການ.",
    "NOT_GRANTED": "ຂໍອະໄພ, ເບີໂທລະສັບຂອງທ່ານບໍ່ໄດ້ຮັບອະນຸຍາດ.",
    "FAIL_TO_CREATE_TOKEN": "ມີບາງຢ່າງບໍ່ຖືກຕ້ອງ, ກະລຸນາໂຫຼດໜ້າຈໍໃໝ່ ແລະ ລອງໃໝ່ອີກຄັ້ງ.",
    "GET_PHONE_NUMBER_BY_UUID_ERROR": "ມີບາງຢ່າງບໍ່ຖືກຕ້ອງ, ກະລຸນາໂຫຼດໜ້າຈໍໃໝ່ ແລະ ລອງໃໝ່ອີກຄັ້ງ.",
    "TEST_NOT_START": "ການສອບເສັງຍັງບໍ່ເລີ່ມ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ.",
    "TEST_TIME_OUT": "ຂໍອະໄພ, ໝົດເວລາການສອບເສັງແລ້ວ.",
    "OUT_OF_TRYTIMES": "ຂໍອະໄພ, ໝົດເວລາລອງແລ້ວ.",
    "TEST_NOT_EXISTED": "ການສອບເສັງແມ່ນກຳລັງປັບປຸງ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ..",
    "TESTS_NOT_FOUND": "ການສອບເສັງແມ່ນກຳລັງປັບປຸງ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ.",
    "TEST_NOT_QUESTIONS": "ການສອບເສັງນີ້ບໍ່ມີຄຳຖາມ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ.",
    "SOME_THING_IS_WRONG": "ມີບາງຢ່າງບໍ່ຖືກຕ້ອງ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ",
    "LESSON_NOT_FOUND": "ບໍ່ພົບບົດຮຽນ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ.",
    "LESSON_NOT_STARTED": "ບົດຮຽນຍັງບໍ່ເລີ່ມ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ.",
    "PREVIOUS_LESSON_NOT_COMPLETE": "ທ່ານຍັງບໍ່ທັນໄດ້ສຳເລັດບົດຮຽນທີ່ຈຳເປັນກ່ອນເທື່ອ, ໃຫ້ສຶກສາແນວທາງທີ່ຖືກຕ້ອງກ່ອນ",
    "QUESTION_NOT_ENOUGH": "ຄຳຖາມແມ່ນກຳລັງປັບປຸງ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ.",
    "ANSWERS_SUBMIT_NULL": "ຄຳຕອບເປົ່າຫວ່າງ, ກະລຸນາລອງໃໝ່ອີກຄັ້ງ.",
    "QUESTION_TYPE_NOT_FOUND": "ບໍ່ພົບປະເພດຄຳຖາມ.",
    "TEST_CODE_NOT_FOUND": "ບໍ່ພົບລະຫັດສອບເສັງ",
    "TL_CODE_NULL": "ລະຫັດ T ຫຼື ລະຫັດ L ເປົ່າຫວ່າງ, ກະລຸນາກັບມາໃໝ່ໃນພາຍຫຼັງ.",
    "ANONYMOUS_AUTHENTICATION_TOKEN": "ສະບາຍດີ! ຂໍອະໄພ, ເບີໂທລະສັບຂອງທ່ານບໍ່ມີຢູ່ໃນລາຍການ.",
    "NO_NETWORK": "ບໍ່ມີສັນຍານເຄືອຂ່າຍ",
};
